import React, { useState, useEffect } from 'react'
import '../../App.css';
import RaspTable from '../RaspTable'
import Api from '../../utils/api';

import { Typography, Grid } from '@mui/material';
import Tab from '@mui/material/Tab';
import {TabContext, TabList, TabPanel} from '@mui/lab';
import RaspSpec from '../RaspSpec';

function MainPage() {
    const api = new Api();
    const [data, setData] = useState([]);
    const [tab, setTab] = useState('1');

    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    useEffect(() => {
      const timer = setInterval(() => {
        send();
      }, 100000);
      return () => clearInterval(timer);
    })

    useEffect(() => {
        send();
    },[])

    const send = () => {
      api.getData("getPedSchedule")
        .then((value) => {
          setData(value.sort((a, b) =>
            a.fio.localeCompare(b.fio, 'ru', { sensitivity: 'base' })
            ));
        })
        .catch((err) => console.log(err));
    }

    return (
    <div className="App">    
        <header className="App-header">
          <Typography variant="subtitle2" fontSize={'1.4rem'}>Расписание врачей ГБУЗ КК ПК ГДП №1</Typography>
          
        </header>
        <div>
          <TabContext value={tab}>
            <Grid container direction="column">
              <Grid className='tab'>
                <TabList onChange={handleChange} orientation='horizontal' variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={{whiteSpace: 'normal', wordBreak: 'break-word',}}>
                  <Tab className='tab-content text-color' label="Участковые педиатры" value="1" />
                  <Tab className='text-color' label="Участковые педиатры, филиал" value="2" />
                  <Tab className='text-color' label="Узкие специалисты" value="3" />
                </TabList>
              </Grid>
              <Grid >
                <TabPanel value="1"><RaspTable data={data.filter(item => !(item.kab < 10))}/></TabPanel>
                <TabPanel value="2"><RaspTable data={data.filter(item => (item.kab < 10))}/></TabPanel>
                <TabPanel value="3"><RaspSpec/></TabPanel>
              </Grid> 
            </Grid> 
          </TabContext>
        </div>
      
    </div>
  );

}

export default MainPage;